import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { OptionalTextAreaTranslationValueInput, RequiredTranslationValueInput, TranslationValueReadonly } from "./TranslationValueInnerForm";

export const mainSection = (
  formUrl: string,
  webformFormState: WebformFormState,
): FormSection => ({
  key: "bookingRequestForm",
  title: RESX.Webform.resxWebform,
  type: "regular",
  fields: [{
    key: "previewForm",
    label: RESX.Webform.PreviewForm,
    render: () => <a rel="noreferrer" target="_blank" href={formUrl}>{RESX.GeneralLabels.ClickHere}</a>
  }, {
    key: "titleInternal",
    label: RESX.GeneralLabels.InternalTitle,
    render: () => <>{webformFormState.titleInternal}</>,
    inPageEdit: {
      render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
        validatorKey="title"
        focusOnMount
        maxLength={serverReference.constants.bookingRequest.maxTitleInternalLength}
        value={value}
        onChange={(title) => { onChange(title); }}
        onEnter={() => submit()}
        onEsc={() => cancel()}
      />,
      fullWidth: true,
      type: "confirmOrCancelButton",
      initialValue: webformFormState.titleInternal,
      submitChange: (titleInternal: string) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        titleInternal,
      }),
    },
  }, {
    key: "header",
    label: RESX.GeneralLabels.Title,
    sublabel: RESX.Webform.TitleSmallLabel,
    render: () => <TranslationValueReadonly values={webformFormState.header} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <RequiredTranslationValueInput
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.header,
      submitChange: (header: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        header,
      }),
    }
  }, {
    key: "description",
    label: RESX.GeneralLabels.Description,
    sublabel: RESX.Webform.DescriptionSmallLabel,
    isEmpty: webformFormState.description.length === 0,
    render: () => <TranslationValueReadonly values={webformFormState.description} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <OptionalTextAreaTranslationValueInput
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.description,
      submitChange: (description: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        description,
      }),
    }
  }]
});